import { Routes } from '@angular/router';

import { JOURNEY_ROUTE } from '../features/public-journey/journey.routes';

export const baseRoutes: Routes = [JOURNEY_ROUTE];
